<template>
  <b-card-code title="Modifier Année universitaire">
    <b-card-text>
      <span>Veuillez modifier les coordonnées de Année universitaire </span>
    </b-card-text>

    <!-- form -->
    <validation-observer
      v-if="academicYear"
      ref="simpleRules"
    >
      <b-form>
        <b-row>
          <b-col md="6">
            <b-form-group
              label="Année"
              label-for="Année"
            >
              <validation-provider
                #default="{ errors }"
                name="Année"
                rules="required"
              >
                <b-form-input
                  v-model="academicYear.academic_year"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Année"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Etat"
              label-for="Etat"
            >
              <validation-provider
                #default="{ errors }"
                name="state"
                rules="required"
              >
                <v-select
                  v-model="academicYear.state"
                  :clearable="false"
                  :options="states"
                  placeholder="Statut de l'année"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <h5>Date début de l'année</h5>
            <b-form-datepicker
              id="example-datepicker"
              v-model="academicYear.start_date"
              class="mb-1"
              placeholder="Date début de l'année"
            />
          </b-col>
          <b-col md="6">
            <h5>Date fin échéancier</h5>
            <b-form-datepicker
              id="example-datepickerr"
              v-model="academicYear.end_date"
              class="mb-1"
              placeholder="Date fin échéancier"
            />
          </b-col>
          <b-col cols="12">
            <b-button
              variant="primary"
              type="submit"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              @click.prevent="editAcademicYears"
            >
              Modifier
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card-code>
</template>

<script>
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import BCardCode from '@core/components/b-card-code'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
/* import vSelect from 'vue-select' */
import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BFormDatepicker,
  BCardText /*  */,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BCardText,
    /* BFormTextarea, */
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    vSelect,
    BFormDatepicker,
  },
  data() {
    return {
      username: '',
      academicYear: {},
      required,
      states: ['Ouverte', 'Clôturée'],

    }
  },
  created() {
    this.getAcademicYears()
  },
  methods: {
    async getAcademicYears() {
      this.load = 'true'
      const { id } = this.$route.params
      const response = await axios.get(`/api/academic-years/detail/${id}`)
      this.academicYear = response.data
      this.load = 'false'
    },
    async editAcademicYears() {
      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
          try {
            await axios
              .put(
                `/api/academic-years/update/${this.academicYear.id}/`,
                {
                  academic_year: this.academicYear.academic_year,
                  state: this.academicYear.state,
                  start_date: this.academicYear.start_date,
                  end_date: this.academicYear.end_date,
                },
              )
            this.$router.push('/academic-years')
            setTimeout(() => {
              this.showToast('success', 'top-center', 'Année universitaire Modifié avec succés')
            }, 1000)
          } catch (err) {
            setTimeout(() => {
              this.showToast('danger', 'top-center', err.toString())
            }, 1000)
          }
        }
      })
    },
    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        {
          position,
        },
      )
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
